//  i need these in english not in hindi

const titles = {
  // Main Routes
  "/": "Home",
  "/explore": "Explore",
  "/events": "Events",
  "/create": "Create",
  "/chat": "Chat",
  "/settings": "Settings",

  // Auth Routes
  "/login": "Login",
  "/register": "Register",
  "/forgot": "Reset Password",
  "/update-password": "Update Password",

  // Profile Routes
  "/profile": "My Profile",
  "/setting/edit": "Edit Profile",
  "/update-profile": "Update Profile",
  "/delete-account": "Delete Account",

  // Content Routes
  "/stories": "Stories",
  "/poetries": "Poems",
  "/story-create": "Write Story",
  "/poem-create": "Write Poem",
  "/videos": "Videos",
  "/movies": "Movies",
  "/audios": "Audio",

  // Contest Routes
  "/contest-story": "Story Contest",
  "/contest-poem": "Poetry Contest",

  // Event Routes
  "/open-mics": "Open Mics",
  "/Storytent-Meeting": "Online Meeting",
  "/Create-Meeting": "Create Meeting",

  // Info Pages
  "/about-us": "About Us",
  "/who-we-are": "Who We Are",
  "/what-we-do": "What We Do",
  "/our-vision": "Our Vision",
  "/our-partner": "Our Partners",
  "/faqs": "FAQs",
  "/privacy-policy": "Privacy Policy",
  "/term-condition": "Terms & Conditions",
  "/cookies-policy": "Cookies Policy",

  // Other Routes
  "/notification": "Notifications",
  "/search": "Search",
  "/setting/language": "Language Settings",
  "/plans": "Plans",
};

// For dynamic routes
const getDynamicTitle = (path) => {
  if (path.startsWith("/profile/")) {
    return "User Profile";
  }
  if (path.startsWith("/story-details/")) {
    return "Story";
  }
  if (path.startsWith("/poem-details/")) {
    return "Poem";
  }
  if (path.startsWith("/openmic/")) {
    return "Open Mic";
  }
  if (path.startsWith("/chat/")) {
    return "Messages";
  }
  return "Home"; // Default fallback
};

export const setPageTitle = (path) => {
  // First check for exact matches
  if (titles[path]) {
    document.title = titles[path];
    return;
  }

  // Then check for dynamic routes
  document.title = getDynamicTitle(path);
};
